import { PlanItem, PlanTable } from '../../ContractedPlan';
import { MainContainer, TableColumns } from './styled/Plans.styled';

interface PlanProps {
  plans?: Record<string, Array<PlanItem>>
}

const defaultProps = {
  plans: {},
};

const Plans = ({
  plans = defaultProps.plans,
}: PlanProps) => (
  <MainContainer>
    {Object.entries(plans).map(([key, value]) => (
      <TableColumns key={key}>
        <h3>{key}</h3>
        <PlanTable planInfo={value} multiRowHover />
      </TableColumns>
    ))}
  </MainContainer>
);

export default Plans;
